import { render, staticRenderFns } from "./ChordProPreview.vue?vue&type=template&id=63e85446&scoped=true"
import script from "./ChordProPreview.vue?vue&type=script&lang=ts"
export * from "./ChordProPreview.vue?vue&type=script&lang=ts"
import style0 from "./ChordProPreview.vue?vue&type=style&index=0&id=63e85446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e85446",
  null
  
)

export default component.exports